// Centralized submenu -> route resolver for modules
export function getSubmenuRoute(moduleKey, submenuKey) {
  if (!moduleKey) return '/';
  const mk = String(moduleKey || '').trim().toLowerCase();
  const sk = String(submenuKey || '').trim();

  const ROUTES = {
    opd: {
      opd_overview: '/opd/overview',
      opd_register: '/opd/register',
      opd_walk_in: '/opd/walk-in',
      opd_queue: '/opd/queue-management',
      opd_reports: '/opd/reports',
      opd_cancel: '/opd/cancel',
      opd_bills: '/opd/bills',
    },
    ipd: {
      ipd_overview: '/ipd/overview',
      ipd_workflow: '/ipd/workflow',
      ipd_docs: '/ipd/documents',
      ipd_doc_discharge: '/ipd/documents/discharge',
      ipd_doc_birth: '/ipd/documents/birth',
      ipd_doc_treatment: '/ipd/documents/treatment',
      ipd_doc_bills: '/ipd/documents/bills',
      ipd_doc_referral: '/ipd/documents/referral',
      ipd_doc_death: '/ipd/documents/death',
      ipd_doc_expense: '/ipd/documents/expense',
      ipd_supplies: '/ipd/supplies',
      ipd_supplies_available: '/ipd/supplies/available',
      ipd_supplies_demand: '/ipd/supplies/demand',
      ipd_supplies_replace: '/ipd/supplies/replace',
      ipd_report: '/ipd/reports',
    },
    emergency: {
      emergency_mlc_policy: '/emergency/mlc-policy',
      emergency_er_protocols: '/emergency/er-protocols',
      emergency_patient_record: '/emergency/patient-record',
    },
    pathology: {
      lab_overview: '/pathology/overview',
      lab_invoices: '/pathology/invoices',
      lab_sample: '/pathology/samples',
      lab_upload: '/pathology/upload',
      lab_supervision: '/pathology/supervision',
      lab_concluded: '/pathology/concluded',
      lab_patient_db: '/pathology/patients',
      lab_inventory: '/pathology/inventory',
      lab_critical: '/pathology/critical',
      lab_finance: '/pathology/finance',
      lab_investigations: '/pathology/investigations',
      lab_centres: '/pathology/centres',
      lab_settings: '/pathology/settings',
    },
    radiology: {
      rad_dashboard: '/radiology/dashboard',
      rad_orders: '/radiology/orders',
      rad_queue: '/radiology/queue',
      rad_schedule: '/radiology/queue',
      rad_studies: '/radiology/studies',
      rad_reporting: '/radiology/reporting',
      rad_verification: '/radiology/verification',
      rad_completed: '/radiology/completed',
      rad_history: '/radiology/patient-record',
      rad_critical: '/radiology/critical-results',
      rad_cash_reconciliation: '/radiology/cash-reconciliation',
      rad_pacs: '/radiology/pacs',
      rad_settings: '/radiology/settings',
    },
    pharmacy: {
      ph_dashboard: '/pharmacy/dashboard',
      ph_pos: '/pharmacy/pos',
      ph_items: '/pharmacy/items',
      ph_inventory: '/pharmacy/inventory',
      ph_inventory_stock_in: '/pharmacy/inventory/stock-in',
      ph_inventory_overview: '/pharmacy/inventory/stock',
      ph_inventory_allocate: '/pharmacy/inventory/allocate',
      ph_inventory_adjustment: '/pharmacy/inventory/adjustment',
      ph_inventory_history: '/pharmacy/inventory/med-history',
      ph_prescriptions: '/pharmacy/prescriptions',
      ph_customers: '/pharmacy/customers',
      ph_suppliers: '/pharmacy/suppliers',
      ph_manufacturers: '/pharmacy/manufacturers',
      ph_sale_purchase: '/pharmacy/sale-purchase-record',
      ph_tax: '/pharmacy/tax-calculation',
      ph_reports: '/pharmacy/reports',
      ph_cash_ledger: '/pharmacy/cash-ledger',
      ph_users: '/pharmacy/users',
      ph_settings: '/pharmacy/settings',
    },
    admin: {
      hr: '/admin/hr',
      hr_overview: '/admin/hr/overview',
      hr_doctors: '/admin/hr/doctors',
      hr_paramedical: '/admin/hr/paramedical',
      services: '/admin/services',
      services_overview: '/admin/services/overview',
      services_add: '/admin/services/add',
      services_edit: '/admin/services/edit',
      services_categories: '/admin/services/categories',
      pathology: '/admin/pathology',
      pathology_investigations: '/admin/pathology/investigations',
      pathology_misc: '/admin/pathology/misc',
      company: '/admin/company',
      templates: '/admin/templates',
    },
  };

  const byModule = ROUTES[mk] || {};
  if (byModule[sk]) return byModule[sk];

  // fallback: try to derive a reasonable path
  const subPath = sk && sk.includes('_') ? sk.split('_').slice(1).join('/') : sk;
  return '/' + mk + (subPath ? '/' + subPath : '');
}

export default { getSubmenuRoute };
